<template>
    <div class="paid-modal-content">
        <app-form ref="form" @on-submit="onSubmit" :schema="schema" :data="formModel" />
        <div v-if="!hideFooterButton" class="footer-buttons">
            <button type="button" v-show="cancelText" class="btn btn-outline-secondary btn-sm" @click="onCancel()">{{
                cancelText }}</button>
            <app-btn-submit v-show="okText" :isSubmitting="isSubmitting" :css="'btn btn-primary btn-sm'" :text="okText"
                @on-click="onOk()" />
        </div>
    </div>
</template>

<script>
import AppForm from '@/components/app-form/';
import { mapActions, mapState } from 'vuex';
import { regexEmail } from '@/utils/regex';
import AppBtnSubmit from '@/components/app-button/index';
import ToastUtils from '@/utils/toast';

export default {
  name: 'InvoicePayForm',
  components: {
    AppForm,
    AppBtnSubmit,
  },
  props: {
    invoiceId: {
      type: [String, Number],
      default: '',
    },
    customer_or_vendor_id: {
      type: [String, Number],
      default: '',
    },
    okText: {
      type: String,
      default() {
        return this.$t('app.update');
      },
    },
  },
  data() {
    return {
      title: this.$t('invoice.paidDate'),
      isSubmitting: false,
      isLoading: false,
      schema: [
        {
          name: 'date_confirm',
          label: this.$t('invoice.paidDate'),
          placeholder: `${this.$t('app.enter')} ${this.$t('invoice.paidDate')}`,
          validation: 'required',
          type: 'datepicker',
        },
        {
          name: 'email',
          addOnKey: [32, ';', ','],
          label: this.$t('invoice.confirmEmailSupplier'),
          placeholder: `${this.$t('app.enter')} ${this.$t('invoice.emailSupplier')}`,
          asyncValidation(value, resolve) {
            if (value.length === 0) {
              resolve(true);
            }

            const isValid = value.every((item, index) => {
              if (!regexEmail.test(item.text)) {
                resolve({ msg: `${this.$t('error.form.email.validate')} ${index + 1}` });
                return false;
              }
              return true;
            });

            if (isValid) {
              resolve(true);
            }
          },
          type: 'tag',
        },
      ],
      formModel: {
        date_confirm: '',
        email: [],
      },
      invoicesId: Set,
      markedInvoices: Map,
    };
  },
  mounted() { },
  created() {
  },
  computed: {
        // checkData() {
        //     const lengthId = [...this.invoicesId].length;
        //     const length = [...this.markedInvoices].length;
        //     if (length === lengthId) {
        //         return true;
        //     }
        //     return false;
        // },
        // generateInvoices() {
        //     const arr = [...this.markedInvoices];
        //     const str = arr.map(invoice => invoice.invoice_number).join(', ');
        //     return `${this.$t('invoice.youHaveChosenToPay')} <strong> ${arr.length} </strong> ${this.$t('invoice.invoiceNumber3')}: <strong>${str}</strong>`;
        // },
        // generateTotalWithTax() {
        //     let total = 0;
        //     if (!this.checkData) {
        //         return total;
        //     }
        //     const arr = [...this.markedInvoices];
        //     arr.forEach((invoice) => {
        //         if (!isNaN(invoice.total_amount_with_tax)) {
        //             total += Number(invoice.total_amount_with_tax);
        //         }
        //     });
        //     return total;
        // },
        // generateTotalWithoutTax() {
        //     let total = 0;
        //     if (!this.checkData) {
        //         return total;
        //     }
        //     const arr = [...this.markedInvoices];
        //     arr.forEach((invoice) => {
        //         if (!isNaN(invoice.total_amount_without_tax)) {
        //             total += Number(invoice.total_amount_without_tax);
        //         }
        //     });
        //     return total;
        // },
    },
    methods: {
        ...mapActions(['setPaidDate', 'setState']),
        onSubmit(formModel) {
            this.isSubmitting = true
            this.$refs.form.validate().then((isValid) => {
                if (isValid) {
                    this.isLoading = true;
                    let emails = '';
                    if (formModel.email && formModel.email.length > 0) {
                        emails = formModel.email.map(item => item.text).join(';');
                    }

                    this.setPaidDate({
                        emails,
                        date_confirm: formModel.date_confirm,
                        invoices_id: [this.invoiceId],
                        vendor_or_customer_id: formModel.customer_or_vendor_id
                    }).then(() => {
                        setTimeout(() => {
                            this.isSubmitting = false
                        }, 500);
                    }).catch((error) => {
                        setTimeout(() => {
                            this.isSubmitting = false
                        }, 500);
                        ToastUtils.showToast('error', error.message || error);
                    });
                }
            });
        },
        onOk() {
            this.$refs.form.submit();
            setTimeout(() => {
                this.$emit('on-pay-invoice', this.formModel.date_confirm);
            }, 500);
        },
        beforeClose() {
            this.formModel = {
                date_confirm: null,
            };
            // this.markedInvoices = Set;
      this.invoiceId = null;
    },
    beforeOpen(params) {
            // this.invoicesId = params.model;
            // this.markedInvoices = params.markedInvoices;
            // this.formModel.email = this.companyMarked.latest_emails ? [{ text: this.companyMarked.latest_emails }] : [];
    },
  },
};
</script>
<style lang="scss">
.paid-modal-content {
    .paid-modal-information {
        padding: 16px;
        margin-bottom: 12px;
        border-radius: 12px;
        gap: 8px;
        display: flex;
        flex-direction: column;
        color: #003AAB;
        background: #CCE4F6;

        p {
            margin: 0;
        }

        //strong {
        //  font-weight: bold;
        //}
    }
}
</style>



// WEBPACK FOOTER //
// src/portal-components/invoice-pay-form.vue